import styled from "styled-components";
import { TitleStyledProps } from "./Title.types";

export const Title2Styled = styled.div<TitleStyledProps>`
  .alelo-title {
    background-color: ${({ $backgroundColor }) =>
      $backgroundColor ? $backgroundColor : "#FFF"};
    &--primary {
      color: #000;
    }
    &--secondary {
      color: #a4e7b3;
    }
  }
`;
